import { inject } from '@angular/core';
import { Router, CanMatchFn } from '@angular/router';

import { UserRole } from '@/app/api/users';
import { PermissionsService } from '@/app/core/services/permissions';

export function userRoleGuard(roleToCheck: UserRole | UserRole[]): CanMatchFn {
  return () => {
    const router = inject(Router);
    const permissionsService = inject(PermissionsService);

    if (permissionsService.hasAnyRoles(Array.isArray(roleToCheck) ? roleToCheck : [roleToCheck])) {
      return true;
    }

    return router.createUrlTree(['/']);
  };
}
